module.exports = __webpack_public_path__ + "img/Rubis_Cercle.10b19036.png";